import { useBuildMonarchURL, useBuildRecognizeURL } from '@bonusly/url';

import { useIsRecognize } from '../../../hooks/use-is-recognize';

type LinkURLProps = {
	isRecognizeRoute?: boolean; // is the link going to a recognize page
	path: string; // the path of the link
};

type LinkURLResult = {
	isCrossDomain: boolean;
	url: string;
};

export const useLinkNavigation = ({ path, isRecognizeRoute = false }: LinkURLProps): LinkURLResult => {
	const onRecognizePage = useIsRecognize();
	const monarchURL = useBuildMonarchURL();
	const recognizeURL = useBuildRecognizeURL();

	// Cross-domain navigation requires a full page reload via window.location.href
	// This happens when: on Recognize going to Monarch, OR on Monarch going to Recognize
	const isCrossDomain = (onRecognizePage && !isRecognizeRoute) || (!onRecognizePage && isRecognizeRoute);

	// if you are currently on a recognize page, and the link is going to a monarch page, return the monarch URL
	if (onRecognizePage && !isRecognizeRoute) {
		return { isCrossDomain, url: monarchURL(path) };
	}

	// if you are currently on a monarch page, and the link is going to a recognize page, return the recognize URL
	if (!onRecognizePage && isRecognizeRoute) {
		return { isCrossDomain, url: recognizeURL(path) };
	}

	// if you are currently on a recognize page, and the link is going to a recognize page, return the path
	// if you are currently on a monarch page, and the link is going to a monarch page, return the path
	return { isCrossDomain, url: path };
};
